const Google_API = "AIzaSyBuv4-WdWOnVmCNlG9rcgixQP3CkkSTnxw";
export const YOUTUBE_API =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key=" +
  Google_API;

export const Youtube_Search_API="https://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q="